// extracted by mini-css-extract-plugin
module.exports = {"root":"HotelSearchBox_root__3aOHx","closeButton":"HotelSearchBox_closeButton__3DBST"};